"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROOT_DB_KEY = void 0;
exports.ROOT_DB_KEY = Buffer.from('__root__');
//# sourceMappingURL=types.js.map